import { FETCH_DROPSHIP_TEMPLATES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_DROPSHIP_TEMPLATES:
      return action.payload
    default:
      return state
  }
}
